// Route names shared by the composition + guards. The v3 names are preserved verbatim —
// deep links, post-login redirects and the ORP-18604 characterization golden table all key
// on them (analysis 05 §5 "Guards & routing").

/** The app home (legacy '/' → '/summary'; guard denials land here). */
export const HOME_ROUTE_NAME = 'Summary'

/** The guest entry (authGuard's `?next=` round-trip target). */
export const LOGIN_ROUTE_NAME = 'Login'

// NOT a registered v4 route, and not pending one either: module 19 is not being built (product
// decision 2026-07-31 — `/admin/*` is a PERMANENT `legacyHardNavigation` ingress, see
// `ingress/pendingCutover.ts`). The name is kept because a sysadmin hitting a guestOnly route is
// still pointed here — exact v3 parity (golden row 28-authed-sysadmin) — and vue-router aborts the
// navigation rather than mis-landing them. It is NOT the way v4 reaches the admin panel: every
// deliberate entry point (the topbar button, `useAccountBootstrapHooks.onNoAccessibleAccount`) hard-
// navigates to `AppEnv.API_ADMIN_URL` instead, because the panel lives on its own origin (ORP-20292).
export const ADMIN_HOME_ROUTE_NAME = 'AdminDashboard'

/**
 * The MCP-only shell's landing route (ORP-21466). It is the target of the MCP branch in
 * `resolvePermissionAccess` (ORP-21656) and the redirect target of the `/mcp` parent, so both
 * read one constant instead of repeating the literal.
 */
export const MCP_HOME_ROUTE_NAME = 'McpAdAccounts'

/**
 * The "this account does not have MCP" card (ORP-21836) — where the reverse MCP branch of
 * `resolvePermissionAccess` sends an account that opened an `/mcp` screen without owning the
 * product. It is NOT part of the MCP shell: it renders in the web layout and declares no
 * `requiresMcp`, which is exactly what stops the branch from firing on its own destination.
 */
export const MCP_ENABLE_ROUTE_NAME = 'McpEnable'
